export const MY_ACCOUNT = {
  fr: {
    titleKey: 'my_account',
    url: '/login',
  },
  default: {
    titleKey: 'my_account',
    url: '/login',
  },
};

export const getMyAccount = (language = 'en') => {
  return MY_ACCOUNT[language] || MY_ACCOUNT.default;
};

export const DATA = {
  fr: [
    {
      titleKey: 'cv',
      type: 'link',
      children: [
        {
          titleKey: 'cv_examples_by_sector',
          type: 'link',
          url: 'exemples-cv',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-search.svg',
          },
        },
        {
          titleKey: 'simple_cv_templates',
          type: 'link',
          url: 'cv-simple',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-pro.svg',
          },
        },
        {
          titleKey: 'creative_cv_templates',
          type: 'link',
          url: 'cv-original',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-creative.svg',
          },
        },
        {
          titleKey: 'create_cv_online',
          type: 'button',
          url: 'https://app.makemycv.fr/create/resume',
        },
      ],
    },
    {
      titleKey: 'cover_letter',
      type: 'link',
      children: [
        {
          titleKey: 'cover_letters_by_sector',
          type: 'link',
          url: 'recherche-lettre-motivation',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-search.svg',
          },
        },
        {
          titleKey: 'cover_letter_example',
          type: 'link',
          url: 'exemple-lettre-de-motivation',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-simple.svg',
          },
        },
        {
          titleKey: 'create_cover_letter_online',
          type: 'button',
          url: 'https://app.makemycv.fr/create/cover-letter',
        },
      ],
    },
    {
      titleKey: 'writing_help',
      type: 'link',
      children: [
        {
          titleKey: 'how_to_make_cv',
          type: 'link',
          url: 'rediger-un-cv',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-cv.svg',
          },
        },
        {
          titleKey: 'make_spontaneous_application',
          type: 'link',
          url: 'faire-une-candidature-spontanee',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-instant.svg',
          },
        },
        {
          titleKey: 'cv_layout',
          type: 'link',
          url: 'presentation-cv',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-layout-structure.svg',
          },
        },
        {
          titleKey: 'application_email',
          type: 'link',
          url: 'mail-de-candidature',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-send.svg',
          },
        },
        {
          titleKey: 'skills_and_qualities',
          type: 'link',
          url: 'competences-cv',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-school.svg',
          },
        },
        {
          titleKey: 'write_cover_letter',
          type: 'link',
          url: 'rediger-une-lettre-de-motivation',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-write.svg',
          },
        },
      ],
    },
    {
      titleKey: 'expert_advice',
      type: 'link',
      children: [
        {
          titleKey: 'find_job_quickly',
          type: 'link',
          url: 'trouver-un-emploi',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-search.svg',
          },
        },
        {
          titleKey: 'succeed_job_interview',
          type: 'link',
          url: 'entretien-embauche',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-star.svg',
          },
        },
        {
          titleKey: 'best_qualities_flaws',
          type: 'link',
          url: 'qualite-defaut-entretien',
          image: {
            url: 'https://cdn.makemycv.fr/files/sites/menu-question.svg',
          },
        },
      ],
    },
  ],
  default: [
    {
      titleKey: 'cv',
      type: 'link',
      children: [
        {
          titleKey: 'create_cv_online',
          type: 'button',
          url: 'https://app.makemycv.com/create/resume',
        },
      ],
    },
    {
      titleKey: 'cover_letter',
      type: 'link',
      children: [
        {
          titleKey: 'create_cover_letter_online',
          type: 'button',
          url: 'https://app.makemycv.com/create/cover-letter',
        },
      ],
    },
  ],
};

export const getMenuItems = (language = 'en') => {
  return DATA[language] || DATA.default;
};
